import React from 'react';

interface CreatePerpBeamButtonProps {
  isVisible: boolean;
  isDisabled: boolean;
  selectedNodeCount: number;
  onCreateBeams: () => void;
}

/**
 * Button for creating perpendicular beams in Perpendicular Mode.
 */
export const CreatePerpBeamButton: React.FC<CreatePerpBeamButtonProps> = ({
  isVisible,
  isDisabled,
  selectedNodeCount,
  onCreateBeams,
}) => {
  if (!isVisible) return null;

  return (
    <div className="fixed bottom-8 right-8 z-50">
      <button
        className={`px-6 py-3 rounded-lg shadow-lg text-lg font-semibold transition-colors
          ${isDisabled ? 'bg-gray-400 text-gray-200 cursor-not-allowed' : 'bg-purple-600 text-white hover:bg-purple-700'}`}
        onClick={onCreateBeams}
        disabled={isDisabled}
        aria-disabled={isDisabled}
        aria-label="Create Perpendicular Beams"
        title="Create Perpendicular Beams"
      >
        + Create {selectedNodeCount > 0 ? `${selectedNodeCount} ` : ''}Perpendicular Beam{selectedNodeCount === 1 ? '' : 's'}
      </button>
    </div>
  );
};

export default CreatePerpBeamButton; 